import type { App } from 'vue'
import { createI18n } from 'vue-i18n'

import en from './messages/en.json'
import es from './messages/es.json'
import fr from './messages/fr.json'
import msa from './messages/msa.json'
import so from './messages/so.json'
import hmn from './messages/hmn.json'

export const useI18n = (app: App) => {
  app.use(
    createI18n({
      legacy: false,
      locale: 'en',
      fallbackLocale: 'en',
      messages: {
        en,
        es,
        fr,
        msa,
        so,
        hmn
      }
    })
  )

  return app
}
